import { useState, useEffect } from "react";
import { api } from "../api";

const PERIODS = ["Today", "Week", "Month", "Year", "All Time"];

export default function EarningsWidget({ token }) {
  const [open, setOpen]     = useState(false);
  const [data, setData]     = useState({});
  const [loading, setLoading] = useState(true);
  const [showAfterTax, setShowAfterTax] = useState(true);

  useEffect(() => {
    api.analytics(token).then(res => {
      // Build period breakdown from sales
      const sales = res.recent_sales || [];
      const now = Date.now();
      const DAY  = 86400000;
      const filter = (ms) => sales.filter(s => {
        const t = new Date(s.created_at).getTime();
        return !isNaN(t) && (now - t) < ms;
      });

      const calc = (arr) => {
        const net   = arr.reduce((a, s) => a + (s.amount || 0), 0);
        const gross = arr.reduce((a, s) => a + (s.gross || Math.round((s.amount||0)/0.7)), 0);
        return { net, gross, count: arr.length };
      };

      setData({
        "Today":    calc(filter(DAY)),
        "Week":     calc(filter(DAY * 7)),
        "Month":    calc(filter(DAY * 30)),
        "Year":     calc(filter(DAY * 365)),
        "All Time": calc(sales),
      });
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [token]);

  const todayVal = data["Today"] ? (showAfterTax ? data["Today"].net : data["Today"].gross) : 0;

  return (
    <div style={styles.wrap}>
      <div style={styles.row} onClick={() => setOpen(!open)}>
        <div>
          <div style={styles.label}>TODAY'S EARNINGS</div>
          <div style={styles.val}>
            {loading ? "..." : `${todayVal.toLocaleString()} R`}
          </div>
        </div>
        <div style={{...styles.arrow, transform: open ? "rotate(180deg)" : "rotate(0deg)"}}>▲</div>
      </div>

      {open && (
        <div style={styles.dropdown}>
          <div style={styles.taxToggle}>
            <span style={{color:"#555",fontSize:11}}>Show:</span>
            <button style={{...styles.pill, background: showAfterTax ? "var(--rbx-accent, #38bdf8)22" : "transparent", color: showAfterTax ? "var(--rbx-accent, #38bdf8)" : "#555"}} onClick={() => setShowAfterTax(true)}>After tax</button>
            <button style={{...styles.pill, background: !showAfterTax ? "var(--rbx-accent, #38bdf8)22" : "transparent", color: !showAfterTax ? "var(--rbx-accent, #38bdf8)" : "#555"}} onClick={() => setShowAfterTax(false)}>Before tax</button>
          </div>
          {PERIODS.map(p => {
            const d = data[p] || { net:0, gross:0, count:0 };
            const val = showAfterTax ? d.net : d.gross;
            return (
              <div key={p} style={styles.periodRow}>
                <span style={styles.periodLabel}>{p}</span>
                <div style={{textAlign:"right"}}>
                  <div style={styles.periodVal}>{val.toLocaleString()} R</div>
                  <div style={styles.periodCount}>{d.count} sales</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const styles = {
  wrap:        { margin:"8px 12px", background:"#0f0f0f", border:"1px solid #1a1a1a", borderRadius:8, overflow:"hidden" },
  row:         { display:"flex", justifyContent:"space-between", alignItems:"center", padding:"10px 14px", cursor:"pointer" },
  label:       { color:"#555", fontSize:10, letterSpacing:1, marginBottom:2 },
  val:         { color:"var(--rbx-accent, #38bdf8)", fontSize:16, fontWeight:700 },
  arrow:       { color:"#444", fontSize:10, transition:"transform .2s" },
  dropdown:    { borderTop:"1px solid #1a1a1a", padding:"10px 14px" },
  taxToggle:   { display:"flex", gap:6, alignItems:"center", marginBottom:10 },
  pill:        { padding:"2px 8px", borderRadius:10, border:"none", cursor:"pointer", fontSize:11 },
  periodRow:   { display:"flex", justifyContent:"space-between", alignItems:"center", padding:"6px 0", borderBottom:"1px solid #111" },
  periodLabel: { color:"#666", fontSize:12 },
  periodVal:   { color:"#fff", fontSize:13, fontWeight:600 },
  periodCount: { color:"#444", fontSize:10 },
};
